/*
 * 公共函数方法
 */
/*eslint-disable*/
import vue from "@/main.js";
import Cookies from 'js-cookie'
import {
  cookieExpires
} from '@/api/config' // cookie保存的天数
import {
  getDeviceType,
  is_wei
} from '@/common/getDeviceType/getDeviceType'

/**
 * 存取token
 */
export const TOKEN_KEY = 'dhgw_manage_admin_token';
export const ACCOUNTORG_KEY = "dhgw_manage_admin_org";

if (!is_wei()) {

  Cookies.set(TOKEN_KEY, getURLParam("token"));
}
// Cookies.set("TOKEN_KEY", getURLParam("token"));
Cookies.set(ACCOUNTORG_KEY, getURLParam("orgId"));
// if (getDeviceType() == 'android') {
//   let info = window.android.getInfo(200); //调用安卓方法获取token
//   let orgId = window.android.getInfo(300); //调用安卓方法获取机构Id
//   // let info = "0";
//   // let orgId = "1"
//   Cookies.set("forest_token", info);
//   Cookies.set("forest_orgId", orgId);
// } else {
//   let token = getURLParam("token");
//   let orgId = getURLParam("orgId");//IOS获取机构Id
//   // let token = "0";
//   // let orgId = "1"
//   Cookies.set("forest_token", token);
//   Cookies.set("forest_orgId", orgId);
// }


export const setToken = token => {
  Cookies.set(TOKEN_KEY, token, {
    expies: cookieExpires || 1
  })
};
export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY)
  if (token) {
    return token
  } else {
    return false
  }
};
export const getOrgId = () => {
  const orgId = Cookies.get(ACCOUNTORG_KEY);
  if (orgId) {
    return orgId;
  } else {
    return false;
  }
};
export const MapByJsonKey = (keyName, arr) => {
  var map = {},
    dest = [];
  for (var i = 0; i < arr.length; i++) {
    var ai = arr[i];
    if (!map[ai[keyName]]) {
      let obj = {};
      obj[keyName] = ai[keyName];
      obj.children = [ai];
      dest.push(obj);
      map[ai[keyName]] = ai;
    } else {
      for (var j = 0; j < dest.length; j++) {
        var dj = dest[j];
        if (dj[keyName] == ai[keyName]) {
          dj.children.push(ai);
          break;
        }
      }
    }
  }
  return dest;
};
/***获取字典值**/
export async function getDictList(name) {
  let arr = "";
  await vue.$api.baseCommon.baseMsg.dictBox.enableItemList(
    name
  ).then(res => {
    if (res.code == "1") {
      arr = res.data ? res.data : "";
    } else {
      vue.$toast(res.msg);
    }
  });
  return arr;
}
/***获取部门列表**/
export async function getDepartment() {
  let arr = "";
  await vue.$api.dictBox.deptList().then(res => {
    if (res.code == "1") {
      arr = res.data ? res.data : "";
    } else {
      vue.$toast(res.msg);
    }
  });
  return arr;
}
/**
 * 从URL中解析参数
 */
export const getParams = url => {
  const keyValueArr = url.split('?')[1].split('&')
  let paramObj = {}
  keyValueArr.forEach(item => {
    const keyValue = item.split('=')
    paramObj[keyValue[0]] = keyValue[1]
  })
  return paramObj
}

/** */
/** */
export function getURLParam(name) {
  //url后面存在#号 所以取值应在window.location.hash中获取
  let after = window.location.hash.split("?")[1];
  if (after) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  } else {
    return null
  }
}
/**
 * 判断一个对象是否存在key，如果传入第二个参数key，则是判断这个obj对象是否存在key这个属性
 * 如果没有传入key这个参数，则判断obj对象是否有键值对
 */
export const hasKey = (obj, key) => {
  if (key) {
    return key in obj
  } else {
    const keysArr = Object.keys(obj)
    return keysArr.length
  }
}

/**
 * 获取系统当前时间
 * @return: string
 */
export const getCurTime = () => {
  const date = new Date()
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate()) +
    ' ' +
    pad(date.getHours()) +
    ':' +
    pad(date.getMinutes()) +
    ':' +
    pad(date.getSeconds())
  )
}

/*
 *获取系统当前日期
 *@return: string
 */
export const getCurData = () => {
  const date = new Date()
  return (
    date.getFullYear() +
    '-' +
    pad(date.getMonth() + 1) +
    '-' +
    pad(date.getDate())
  )
}
/*
 *获取系统当前月1号（2019-12-23）
 *@return: string
 */
 export const getCurMonth = () => {
  const date = new Date();
  return (
    date.getFullYear() +
    "/" +
    pad(date.getMonth() + 1) +
    "/01" 
  );
};
/*
 *标准时间转换成YY-MM-DD hh:MM:ss格式
 *@return: string
 */
export const dateTimeFormat = val => {
  let hour = val.getHours()
  hour = hour.toString()
  if (hour.length < 2) {
    hour = '0' + hour
  }

  let minute = val.getMinutes()
  minute = minute.toString()
  if (minute.length < 2) {
    minute = '0' + minute
  }

  let second = val.getSeconds()
  second = second.toString()
  if (second.length < 2) {
    second = '0' + second
  }

  return (
    val.getFullYear() +
    '-' +
    pad(val.getMonth() + 1) +
    '-' +
    pad(val.getDate()) +
    ' ' +
    hour +
    ':' +
    minute +
    ':' +
    second
  )
}

/*
 *标准时间转换成YY-MM-DD格式
 *@return: string
 */
export const dateFormat = val => {
  return (
    val.getFullYear() + '-' + pad(val.getMonth() + 1) + '-' + pad(val.getDate())
  )
}

/**
 * 转换补0
 * @return: string
 */
export const pad = n => {
  return n < 10 ? '0' + n : n
}

/**
 * @msg: 获取系统当前时间
 * date 时间
 *  fmt 时间格式
 * @return: string
 */
export const formatDate = (date, fmt) => {
  let time = ''
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'H+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    time = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      time = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return time
}
/*计算时间差*/
export const intervalTime = (startTime, endTime, type) => {
   //ios下  new Date生效需要更换方式
  var date1 = new Date(startTime.toString().replace(/-/g, '/')); //开始时间
  var date2 = new Date(endTime.toString().replace(/-/g, '/')); //结束时间
  var date3 = date2.getTime() - date1.getTime(); //时间差的毫秒数
  //计算出相差天数
  var days = Math.floor(date3 / (24 * 3600 * 1000));
  //计算出小时数
  var leave1 = date3 % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000));
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000));
  //计算相差秒数

  var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000);
  // console.log(" 用时： " + days + "天 " + hours + "小时 " + minutes + " 分钟" + seconds + " 秒",'时间差')
  if (type == '1') { //type=1,返回时长（单位为天：0.65）
    let num = days + hours / 24 + minutes / (60 * 24)
    return num.toFixed(2)
  } else if (type == '2') { //type = 2,返回时间差为负数的
    if (days < 0 || hours < 0 || minutes < 0 || seconds < 0) {
      return false
    } else {
      return true
    }
  }else if(type == "3"){
    /*返回相差得分钟数*/
    console.log(date1,'startTime')
    console.log(date2,'endTime')
    console.log(date2.getTime() - date1.getTime(),'date3')
    let minutesNum = date3 / (60 * 1000)
    return minutesNum.toFixed(2);
  }
};

/*两个日期之间所有月份间隔*/
export const diffMonth = (start, end) => {
  var result = [];
  var s = start.split("-");
  var e = end.split("-");
  var min = new Date();
  var max = new Date();
  min.setFullYear(s[0], s[1]);
  max.setFullYear(e[0], e[1]);
  var curr = min;
  while (curr <= max) {
    var month = curr.getMonth();
    var month1 = pad(curr.getMonth())
    var str = curr.getFullYear() + "-" + (month1);
    var s = curr.getFullYear() + "-0";
    if (str == s) {
      str = curr.getFullYear() + "-12";
    }
    result.push(str);
    curr.setMonth(month + 1);
  }
  return result;
};
export const dateCompare = (startDate, endDate) => {
  //比较俩个日期时间大小
  let startDateTemp = new Date(startDate.replace('-', '/'))
  let endDateTemp = new Date(endDate.replace('-', '/'))
  return startDateTemp > endDateTemp
}

/**
 * 校验手机号是否正确
 * phone 手机号
 */

export const verifyPhone = phone => {
  const reg = /^1[34578][0-9]{9}$/
  const _phone = phone.toString().trim()
  let toastStr =
    _phone === '' ? '手机号不能为空~' : !reg.test(_phone) && '请输入正确手机号~'
  return {
    errMsg: toastStr,
    done: !toastStr,
    value: _phone
  }
}

export const verifyStr = (str, text) => {
  const _str = str.toString().trim()
  const toastStr = _str.length ? false : `请填写${text}～`
  return {
    errMsg: toastStr,
    done: !toastStr,
    value: _str
  }
}

// 截取字符串
export const sliceStr = (str, sliceLen) => {
  if (!str) {
    return ''
  }
  let realLength = 0
  const len = str.length
  let charCode = -1
  for (let i = 0; i < len; i++) {
    charCode = str.charCodeAt(i)
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1
    } else {
      realLength += 2
    }
    if (realLength > sliceLen) {
      return `${str.slice(0, i)}...`
    }
  }

  return str
}

/**
 * JSON 克隆
 * jsonObj json对象
 * return 新的json对象
 */
export function objClone(jsonObj) {
  let buf
  if (jsonObj instanceof Array) {
    buf = []
    let i = jsonObj.length
    while (i--) {
      buf[i] = objClone(jsonObj[i])
    }
    return buf
  } else if (jsonObj instanceof Object) {
    buf = {}
    for (let k in jsonObj) {
      buf[k] = objClone(jsonObj[k])
    }
    return buf
  } else {
    return jsonObj
  }
}
export function timeago(dateTimeStamp) {
  //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
  let result = "";
  var time1 = new Date(dateTimeStamp.replace(/-/g, "/")).getTime();
  var minute = 1000 * 60; //把分，时，天，周，半个月，一个月用毫秒表示
  var hour = minute * 60;
  var day = hour * 24;
  var week = day * 7;
  var halfamonth = day * 15;
  var month = day * 30;
  var now = new Date().getTime(); //获取当前时间毫秒
  var diffValue = now - time1; //时间差
  if (diffValue < 0) {
    return;
  }
  var minC = diffValue / minute; //计算时间差的分，时，天，周，月
  var hourC = diffValue / hour;
  var dayC = diffValue / day;
  var weekC = diffValue / week;
  var monthC = diffValue / month;
  if (diffValue >= 0 && diffValue <= minute) {
    result = "刚刚";
  } else if (minC >= 1 && minC <= 59) {
    result = parseInt(minC) + "分钟前";
  } else if (hourC >= 1 && hourC <= 23) {
    result = parseInt(hourC) + "小时前";
  } else {
    result = parseInt(dayC) + "天前";
  }
  return result;
}
export function Showswiper(imgList, showIndex) {
  //查看预览图片
  let magnifyList = [];
  imgList.forEach(SelectBigImgs);

  function SelectBigImgs(item) {
    magnifyList.push(item);
  }
  let data = {
    showImgs: magnifyList,
    swipercliclIndex: showIndex,
    swiperShow: true
  };
  if (magnifyList.length > 0) {
    vue.$store.commit("setDataImgs", data);
  }
}
//字典名称转换
export function getDictName(value, dictArr) {
  console.log(value, dictArr)
  if (value != null) {
    let arr = dictArr.filter(item => item.value == value)
    return arr[0].name
  } else {
    return ''
  }
}
//判断手机是否是iphone以上手机
export const isIphonex = () => {
  if (typeof window !== 'undefined' && window) {
    return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
  }
  return false;
};
//判断是否可以编辑/审批
export function isEdit(state, type) {
  return (state == 'hold' || state == 'deny') || (type == 'verify' && state == 'pending') || (type == 'verify' && state == 'doing') ? true : false
}
export const getDataArray = (dateNumber) => {
  let obj = {}
  obj.endTime = getCurData('day')
  let date = new Date() //获取当前时间
  date.setMonth(date.getMonth() - dateNumber); //向前取对应的日期
  obj.startTime = dateFormat(date, "yyyy-MM")
  return obj
}